import React from 'react';
import './sidebarControlPanel.css';

const SidebarControlPanel = (props) => {

  const {switchChosenLabel, roleFilter, chosenLabel, updateSidebarState} = props;

  // Updates the parent state with the selected filter.
  const handleRoleFilterClick = e => {
    const updatedRoleFilter = {...roleFilter};
    updatedRoleFilter[e.target.value] = e.target.checked;
    updateSidebarState({roleFilter: updatedRoleFilter});
  };

  // A componenet that consists of a checkbox and a label.
  const FilterInput = ({role}) => {
    return (
      <div>
        <input
          checked={roleFilter[role]}
          id={`${role}_checkbox`}
          name="roleFilter"
          onChange={handleRoleFilterClick}
          type="checkbox"
          value={role}
        />
        <label htmlFor={`${role}_checkbox`}>{role}</label>
      </div>
    );
  };

  return (
    <div className="SidebarControlPanelPage">
      <button className="UnmonitoredInstanceButton" onClick={switchChosenLabel}>
        {chosenLabel !== 'InstanceId' ? 'List by IDs' : 'List by Names'}
      </button>
      <FilterInput role="*NO ROLE*"/>
      <FilterInput role="DR"/>
      <FilterInput role="Development"/>
      <FilterInput role="Production"/>
      <FilterInput role="QA"/>
    </div>
  );

};

SidebarControlPanel.propTypes = {

};

export default SidebarControlPanel;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/sidebar/sidebarControlPanel/sidebarControlPanel.js